import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import tw from "tailwind-styled-components";
const StyledHr = tw.hr`
  ${({ $margin })=>{
    return `
      border-0
      border-b
      border-opacity-7
      border-white
      w-full
      ${$margin}
    `;
}}
`;
const StyledDiv = tw.div`
  ${({ $margin })=>{
    return `
      bg-white
      bg-opacity-7
      w-[1px]
      ${$margin}
    `;
}}
`;
const SDivider = ({ orientation = "horizontal", margin = "" })=>{
    if (orientation === "horizontal") {
        return /*#__PURE__*/ _jsx(StyledHr, {
            $margin: margin
        });
    }
    return /*#__PURE__*/ _jsx(StyledDiv, {
        $margin: margin
    });
};
export { SDivider };
